import { useState, useEffect } from 'react';
import { Form, DatePicker, Input, Row, Col /*message*/ } from 'antd';
import moment from 'moment';
import regex from '../utils/helper';
import { ModalComponent } from '@operations/shared';
import { ICollection } from '../utils/commonInterfaces';

interface EditCollectionModalProps {
    visible: boolean;
    collectionData?: ICollection;
    onCancel: () => void;
    onUpdate?: ((values: any) => Promise<void>);
}

export default function EditCollectionModal({
    visible,
    collectionData,
    onCancel,
    onUpdate
}: EditCollectionModalProps) {
    const [form] = Form.useForm();
    const validation: any = regex.regexValidation;
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible && collectionData) {
            form.setFieldsValue({
                collectionDate: collectionData.collectionDate ? moment(collectionData.collectionDate) : null,
                companyName: collectionData.companyName || '',
                serialNumber: collectionData.serialNumber || '',
                amount: Number(collectionData.amount)   || 0,
            });
        } else if (!visible) {
            form.resetFields();
        }
    }, [visible, collectionData, form]);

    const handleUpdate = async () => {
        // onCancel();
        // try {
        const values = await form.validateFields();
        setLoading(true);

        if (onUpdate) {
            await onUpdate({
                ...collectionData,
                collectionDate: moment(values.collectionDate).format('YYYY-MM-DD'),
                amount: values.amount,
            });
        }

        //     message.success('Updated successfully');
        setLoading(false);
        //     onCancel();
        // } catch (error: any) {
        //     if (error.errorFields) {
        //         return;
        //     }
        //     message.error('Failed to update collection');
        //     setLoading(false);
        // }
    };

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    return (
        <ModalComponent
            title="Edit Collection"
            visibleModal={visible}
            handleCloseModal={handleCancel}
            handleAcceptModal={handleUpdate}
            loadingConfirm={loading}
            okText="Update"
            cancelText="Cancel"
            content={
                <div style={{ width: '520px', minWidth: '520px', maxWidth: '520px' }}>
                    <Form form={form} layout="vertical" autoComplete="off">
                        <Row gutter={16}>
                            <Col span={24}>
                                <label>Collection Date <span>*</span></label>
                                <Form.Item
                                    name="collectionDate"
                                    rules={[
                                        { required: true, message: 'Collection Date is required' },
                                        {
                                            validator: (_, value) => {
                                                if (!value) {
                                                    return Promise.resolve();
                                                }
                                                if (value && moment(value).isAfter(moment(), 'day')) {
                                                    return Promise.reject('Collection Date cannot be a future date');
                                                }
                                                return Promise.resolve();
                                            }
                                        }
                                    ]}
                                    style={{ marginTop: '2px', marginBottom: '12px' }}
                                >
                                    <DatePicker
                                        format="YYYY/MM/DD"
                                        style={{ width: '100%' }}
                                        disabledDate={(current) => {
                                            return current && current > moment().endOf('day');
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <label>Company Name <span>*</span></label>
                                <Form.Item name="companyName" style={{ marginTop: '2px', marginBottom: '12px' }}>
                                    <Input disabled />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <label>Serial Number <span>*</span></label>
                                <Form.Item name="serialNumber" style={{ marginTop: '2px', marginBottom: '12px' }}>
                                    <Input disabled />
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <label>Amount <span>*</span></label>
                                <Form.Item
                                    name="amount"
                                    rules={[
                                        { required: true, message: 'Amount is required' },
                                        { pattern: validation.positiveFloatNumbers, message: 'Amount must be greater than or equal to 0' }
                                    ]}
                                    style={{ marginTop: '2px' }}
                                >
                                    <Input style={{ width: '100%' }} placeholder="Enter amount" min={0} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
            }
        />
    );
}
